var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    enableBackground: "new 0 0 1417.3 1417.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M0,465.1v-44.3c0-36.7,29.7-66.4,66.4-66.4H1063V221.5c0-59.1,71.7-88.7,113.4-47l221.5,221.5 c25.9,25.9,25.9,68,0,94l-221.5,221.5c-41.6,41.6-113.4,12.4-113.4-47V531.5H66.4C29.7,531.5,0,501.8,0,465.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#062AFF",
    d: "M1350.9,885.8H354.3V753c0-59-71.6-88.8-113.4-47L19.5,927.4c-25.9,25.9-25.9,68,0,94l221.5,221.5 c41.6,41.6,113.4,12.4,113.4-47V1063h996.6c36.7,0,66.4-29.7,66.4-66.4v-44.3C1417.3,915.6,1387.6,885.8,1350.9,885.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.11c4964c24532954d8a7c3a5bb1ff302.svg";
export { ForwardRef as ReactComponent };